import { render, staticRenderFns } from "./MailSentFailed.vue?vue&type=template&id=d09b7ac6"
import script from "./MailSentFailed.vue?vue&type=script&lang=js"
export * from "./MailSentFailed.vue?vue&type=script&lang=js"
import style0 from "./MailSentFailed.vue?vue&type=style&index=0&id=d09b7ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports